export default __webpack_public_path__ + "static/media/CIA-Debit-Order-Authority.da01b74a.pdf";